import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {marketingMobileCuttoff, black, white, ipadproMax} from "@css/constants";
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export const PublicFooterContainer = styled('footer')(css`
  display: flex;
  flex-direction: column;
  background-color: ${black};

  @media(max-width: ${marketingMobileCuttoff}) {
    padding: 0 0px;
    flex-direction: column;
  }
`)

export const PublicFooterRow = styled('div')(css`
  display: flex;
  flex-direction: row;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding: 0 0px;
    flex-direction: column;
  }
`)

export const PublicFooterColumn = styled('div')(css`
  display: flex;
  flex-direction: column;
  width: 10%;

`)

export const PublicFooterEmptyColumn = styled(PublicFooterColumn)(css`
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 5%;
  }
`)

export const PublicFooterEmptyColumnRight = styled(PublicFooterColumn)(css`
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 0%;
  }
`)

export const PublicFooterCopyrightContainer = styled(PublicFooterRow)(css`
  width: 80%;
  border-top: 1px solid #979797;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 90%;
    margin-left: 20px;
    align-items: center;
  }

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 100%;
  }
`)

export const PublicFooterCopyrightColumn = styled(PublicFooterColumn)(css`
  width: 35%;
  margin-top: 30px;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    align-items: center;
  }
`)

export const PublicFooterSmallLetterColumn = styled(PublicFooterColumn)(css`
  width: 65%;
  margin-top: 30px;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
  }
`)

export const PublicFooterSpaceBetween = styled('div')(css`
  height: 25px;
`)

export const PublicFooterInfoColumn = styled('div')(css`
  width: 20%;
  float: left;
  flex-direction: column;
  margin-top: 51px;
  margin-bottom: 25px;
  background-color: ${black};

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    float: none;
    padding-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 25%;
  }
`)

export const PublicFooterTitle = styled('h3')(css`
  ${fontSize(24)};
  ${FontNormal(600)};

  margin-bottom: 10px;
  color: ${white};

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-bottom: 5px;
    padding: 10px 0;
  }
`)

export const PublicFooterSubtitle = styled('h3')(css`
  ${fontSize(18)};
  ${FontNormal(600)};
  color: ${white};
`)

export const PublicFooterLink = styled('a')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  color: ${white};
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 15px;
  margin-top: 24px;
  display: flex;
  text-decoration: none;
`)

export const PublicFooterLinkNoMarginTop = styled(PublicFooterLink)(css`
  margin-top: 12px;
`)

export const PublicFooterRegularText = styled('p')(css`
  ${fontSize(16)};
  ${FontNormal(500)};
  width: 85%;
  color: ${white};

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
  }
`)

export const PublicFooterSmallText = styled('p')(css`
  ${fontSize(12)};
  ${FontNormal(400)};
  width: 85%;
  color: ${white};
  padding-bottom: 2px;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
  }
`)

export const PublicFooterSmallTextMarginBottom = styled(PublicFooterSmallText)(css`
  margin-bottom: 15px;
  width: 95%;
`)

export const PhoneNumberWrapper = styled('span')(css`
  ${fontSize(16)};
  ${FontNormal(500)};
  width: 85%;
  color: ${white};
  text-decoration: underline;
  cursor: pointer;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
  }
`);
